import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  title: string
  imageSrcKey: string
  altText: string
  score: string
}
const mediaQuery = [{ screen: '(min-width: 280px)', width: '100px' }]
export default function StatOverview({ title, imageSrcKey, altText, score }: Props): React.ReactElement {
  return (
    <div className="w-full flex flex-col items-center justify-center grow font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
      <p>
        <span className="text-purple">{title}</span>
      </p>
      <ResponsiveImage
        alt={altText}
        imageClassName="h-20"
        imageWidths="60, 120, 200"
        mediaQuery={mediaQuery}
        srcKey={imageSrcKey}
      />
      <p>{score}</p>
    </div>
  )
}
